import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Style/Logout.css';
import TopNavbar from '../home/TopNavbar';


const Logout = () => {
    const navigate = useNavigate();
    // State to handle popup visibility
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        const phoneFromStorage = localStorage.getItem('userPhone');
        if (!phoneFromStorage) {
            navigate('/login');
        }
    }, [navigate]);



    const registerDate = localStorage.getItem('registerDate');
    const lastLogin = localStorage.getItem('lastLogin');


    const handleLogout = () => {
        localStorage.removeItem('userPhone');
        localStorage.removeItem('userEmail');
        localStorage.removeItem('userName');
        localStorage.removeItem('userClass');
        localStorage.removeItem('registerDate');
        localStorage.removeItem('lastLogin');
        localStorage.removeItem('userPayment');
        document.cookie = "userPhone=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict";
        navigate('/login');
    };

    return (

        <div className="logout-page-container">

            <TopNavbar name="Logout" />

            <div className="logout-content-wrapper">
                <div className="logout-card">
                    {/* Clicking this now opens the warning popup instead of logging out immediately */}
                    <button onClick={() => setShowPopup(true)} className="btn-action logout-trigger-btn">
                        Logout
                    </button>
                </div>
            </div>

            {/* Warning Popup Modal */}
            {showPopup && (
                <div className="popup-overlay">
                    <div className="popup-card">
                        <div className="popup-warning-icon">⚠️</div>
                        <h3>Are you sure?</h3>
                        <p>You will need to enter your phone number and credentials to log back in.</p>

                        <div className="popup-actions">
                            <button onClick={() => setShowPopup(false)} className="btn-popup btn-cancel">
                                Cancel
                            </button>
                            <button onClick={handleLogout} className="btn-popup btn-confirm">
                                Yes, Logout
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Logout;